export default "__VITE_ASSET__CiThm1wk__"